import {FC, memo } from 'react';

const BookmarkIcon16Fill: FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.8335 4.11765C2.8335 2.69927 3.92624 1.5 5.3335 1.5H10.6668C12.0741 1.5 13.1668 2.69927 13.1668 4.11765V15.1753L8.00016 10.202L2.8335 15.1753V4.11765Z" fill="#FEFEFE"/>
    </svg>
  );
}

export default memo(BookmarkIcon16Fill);
import {FC, memo } from 'react';

const BookmarkIcon16Fill: FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.8335 4.11765C2.8335 2.69927 3.92624 1.5 5.3335 1.5H10.6668C12.0741 1.5 13.1668 2.69927 13.1668 4.11765V15.1753L8.00016 10.202L2.8335 15.1753V4.11765Z" fill="#FEFEFE"/>
    </svg>
  );
}

export default memo(BookmarkIcon16Fill);
